import { Page } from '../common/pwa/page';
import { checkVisible } from '../common/check-visible';

const getElements = () => [...document.querySelectorAll('*[data-module]')];

const combosNames = [
    ["grillaHoy"],
    ["historias", "columnistas"],
    ["que-sigo", "club", "masLeidasSitio"],
    ["comercial_1", "tema_3", "categoria_1"],
    ["tema_4", "tema_5", "comercial_2", "categoria_2"],
    ["tema_6", "categoria_3"],
    ["categoria_4", "tema_7"],
    ["tePuedeInteresar", "footer"],
];

const getCombos = combos => combos.map(c => ({ Modulos: comboSelector(c) }));

const comboSelector = names => names.map(n => document.querySelector(`[data-module="${n}"]`) || createFake(n));

const createFake = name => {
    const elem = document.createElement("div");
    elem.dataset.module = name;
    elem.dataset.isLoaded = true;
    elem.dataset.isLoading = false;

    return elem;
}

//const modules = elements.map(e => e.dataset.module).filter(e => !!e);
//const page = Page({});
export const init = (scrollPercentToLoad = 75) => {
    const events = {};
    const eventManager = {
        on: (eventName, moduleName, cb) => {
            events[eventName] = events[eventName] || {};
            events[eventName][moduleName] = events[eventName][moduleName] || [];

            events[eventName][moduleName].push(cb);

            return eventManager;
        },
        emit: (eventName, moduleName, ...args) => {
            if (events[eventName]) {
                if (events[eventName][moduleName]) {
                    return events[eventName][moduleName].map(fn => fn(...args));
                }
            }

            return eventManager;
        }
    };





    const getScrollPercent = () => {
        var h = document.documentElement,
            b = document.body,
            st = 'scrollTop',
            sh = 'scrollHeight';
        return (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;
    }

    const cargarComboSiguiente = list => {
        var toLoad = list.splice(0, 1)[0].Modulos;
        toLoad = toLoad.filter(m => m != null);


        eventManager.emit('pre-load', 'ALL', toLoad);
        toLoad.forEach(m => {
            eventManager.emit('pre-load', m.dataset.module, m);
            m.dataset.isLoading = true;
        });
        const page = Page({});

        return page
            .loadModulesWithJS(toLoad)
            .then(result => {
                eventManager.emit('load', 'ALL', result);
                result.forEach(m => {
                    eventManager.emit('load', m.dataset.module, m);

                    m.dataset.isLoaded = true;
                    m.dataset.isLoading = false;
                });
            })
            .catch(e => console.error(e));
    }

    const modulosEnPantalla = (pos) => {
        let combos = getCombos(combosNames);
        const modulos = combos[pos].Modulos.filter(m => {
            if (m != null) {
                return m.offsetTop < window.innerHeight && (m.dataset && !m.dataset.isLoaded);
            } else {
                return false;
            }
        });

        if (modulos.length) {
            cargarComboSiguiente([{
                Modulos: modulos
            }]).then(() => {
                modulosEnPantalla(1);
            });
        }
    }

    const obtenerModulosOnScroll = () => {
        const combos = getCombos(combosNames);
        const list = combos.filter(function (el) {
            var modules = el.Modulos.filter(function (m) {
                if (m != null) {
                    return !m.dataset.isLoading && !m.dataset.isLoaded;
                } else {
                    return false;
                }
            })
            return modules.length > 0
        })
        const loadingCombo = combos.filter(function (el) {
            var modules = el.Modulos.filter(function (m) {
                if (m != null) {
                    return m.dataset.isLoading == "true";
                } else {
                    return false;
                }
            })
            return modules.length > 0
        })

        if (list.length > 0 && getScrollPercent() > scrollPercentToLoad && loadingCombo.length == 0) {
            cargarComboSiguiente(list);
        }
    }
    modulosEnPantalla(0);
    document.addEventListener('scroll', e => obtenerModulosOnScroll());
    eventManager.onLoad = (moduleName, cb) => eventManager.on('load', moduleName, cb);
    eventManager.onPreLoad = (moduleName, cb) => eventManager.on('pre-load', moduleName, cb);

    return eventManager;
};


// WEBPACK FOOTER //
// ./Statics/scripts/home/modulos.js